import Grid from '@mui/material/Grid';
import SectionStructure from '../../../../components/Section/SectionStructure';
import BioAgeText from './BioAgeText';
import ClockCard from './Clock/ClockCard';
import EpiRiskCard from './EpiRisk/EpiRiskCard';



//import LongevityCard from '../SectionGenetics/Longevity/LongevityCard';


export default function SectionBioAge() {

    
    return (

        <SectionStructure
    
            sectiontext={ <BioAgeText />  }
            sectioncards={ 
            
                <Grid container spacing={2} sx={{display:'flex', justifyContent:'center'}}>   
                   <Grid size={{sm:12, xl:6}} sx={{display:'flex', justifyContent:'center'}}> <ClockCard />    </Grid>
                    <Grid size={{sm:12, xl:6}} sx={{display:'flex', justifyContent:'center'}}> <EpiRiskCard />  </Grid>
                </Grid>
           }

        />

       
    )
}